import styled from 'styled-components';

export const SnackbarContainer = styled.div`
  position: fixed;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: auto;
  display: flex;
  justify-content: center;
`;
